import { Timestamp } from 'firebase/firestore';

/**
 * Interface for SOP Summary stored in Firestore
 */
export interface SOPSummary {
  id: string;                // Matches the SOP ID
  shortSummary: string;      // Single-sentence casual summary
  detailedSummary: string;   // Two-paragraph detailed summary
  keywords: string[];        // Hidden keywords used for search only
  generatedAt: Timestamp;    // When the summary was created
  status: SOPSummaryStatus;  // Status of the summary generation
  errorMessage?: string;     // If status is 'error'
  processingTime?: number;   // Time taken to generate in ms
  docLength?: number;        // Approximate word count
  modelUsed?: string;        // AI model used for generation
}

/**
 * Status of the SOP summary generation
 */
export type SOPSummaryStatus = 'pending' | 'completed' | 'error' | 'permission_denied';

/**
 * Constants for SOP summary collection
 */
export const SOP_SUMMARIES_COLLECTION = 'sopSummaries';

/**
 * Interface for SOP with summary
 */
export interface SOPWithSummary {
  id: string;
  title: string;
  department: string;
  link: string;
  dateCreated: string;
  author1?: string;
  author2?: string;
  tags?: string[];
  shortSummary?: string;
  detailedSummary?: string;
  keywords?: string[];
  hasSummary: boolean;
  summaryStatus?: SOPSummaryStatus;
  flaggedForReview?: boolean;
  flagReason?: string;
  flaggedBy?: string;
  flaggedAt?: string;
}

/**
 * Statistics about SOP summaries
 */
export interface SOPSummaryStats {
  total: number;
  completed: number;
  pending: number;
  error: number;
  permissionDenied: number;
  averageProcessingTime?: number;
  averageDocLength?: number;
}
